import { ApiRequest, GetBaseServiceFunctions } from '../baseService'

const BaseRoute = 'app/ndis-service-items'

const baseFunctions = GetBaseServiceFunctions(BaseRoute)

function ExportSearchResult(payload = {}) {
  return ApiRequest.post(`${BaseRoute}/export`, payload, {
    responseType: 'arraybuffer',
  })
}
function GetListServiceItemRates(payload = {}) {
  return ApiRequest.get(`${BaseRoute}/item-rates`, {
    params: payload,
    paramsSerializer: {
      indexes: true,
    },
  })
}

function Enable(id) {
  return ApiRequest.put(`${BaseRoute}/${id}/enable`)
}

function Disable(id) {
  return ApiRequest.put(`${BaseRoute}/${id}/disable`)
}

const API = {
  ...baseFunctions,
  ExportSearchResult,
  GetListServiceItemRates,
  Enable,
  Disable,
}

export default API
